





import { Component, Vue, Prop } from 'vue-property-decorator'

@Component<DistrictsLayoutView>({})
export default class DistrictsLayoutView extends Vue {}
